import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FastAverageColor } from "fast-average-color";
import { track } from "@herb/utils/analytics";

// Extend dayjs with customParseFormat plugin
dayjs.extend(customParseFormat);

const AdventCalendarDoor = ({
  index,
  doorOpeningDate,
  doorImage,
  doorTitle,
  numberPosition,
  onDoorClick
}) => {
  const [textColor, setTextColor] = useState("#313131");

  // Parse date with correct DD/MM/YYYY format
  const openingDate = dayjs(doorOpeningDate, "DD/MM/YYYY h:mm a").toDate();
  const isDoorOpen = openingDate <= new Date();

  let currentNumberPosition = "top-left";
  switch (numberPosition) {
    case "Top Left":
      currentNumberPosition = "top-left";
      break;
    case "Top Right":
      currentNumberPosition = "top-right";
      break;
    case "Bottom Left":
      currentNumberPosition = "bottom-left";
      break;
    case "Bottom Right":
      currentNumberPosition = "bottom-right";
      break;
  }

  useEffect(() => {
    if (doorImage?.sourceUrl) {
      const fac = new FastAverageColor();

      fac
        .getColorAsync(doorImage.sourceUrl)
        .then(color => {
          // Use a high threshold - if brightness is less than 185 (out of 255), use white text
          // This is very aggressive towards white text
          const brightness =
            (color.value[0] + color.value[1] + color.value[2]) / 3;
          setTextColor(brightness < 180 ? "white" : "#313131");
        })
        .catch(() => {
          // Fallback to white text if image fails to load
          setTextColor("white");
        });
    }
  }, [doorImage?.sourceUrl]);

  const handleClick = () => {
    // Track door click with UTM parameters
    track("Advent Calendar Door Click", {
      doorNumber: index + 1,
      doorStatus: isDoorOpen ? "open" : "closed",
      utm_source: "herb-advent-calendar",
      utm_medium: "cta",
      utm_campaign: "advent-2025",
      utm_content: `door-${String(index + 1).padStart(2, '0')}`
    });
    
    onDoorClick(index, isDoorOpen);
  };

  return (
    <div
      className={`advc-door ${isDoorOpen ? "open" : "closed"}`}
      onClick={handleClick}
      style={{
        backgroundImage: `url(${doorImage?.sourceUrl})`
      }}
    >
      <span
        className={`advc-door-number position-${currentNumberPosition}`}
        style={{ color: textColor }}
      >
        {index + 1}
      </span>
      {doorTitle && <div className="advc-door-title">{doorTitle}</div>}
    </div>
  );
};

export default AdventCalendarDoor;
